import { AxiosResponse } from 'axios';

import { apiRequest } from './index';

export const validatePromoCode = async (easyTabRestName: string, data: Object) => {
  const response: AxiosResponse = await apiRequest.post(`/ordering/${easyTabRestName}/validate_promo_code`, data);

  return response.data;
};
